import { useEffect } from "hono/jsx";

interface GeoPlayerMenuProps {
  x: number;
  y: number;
  playerId: string;
  onClose: () => void;
  onKick?: (playerId: string) => void;
  onBan?: (playerId: string) => void;
}

export const GeoPlayerMenu = (
  { x, y, playerId, onClose, onKick, onBan }: GeoPlayerMenuProps,
) => {
  // Close on global click
  useEffect(() => {
    const handleClick = () => onClose();
    globalThis.window?.addEventListener("click", handleClick);
    return () => globalThis.window?.removeEventListener("click", handleClick);
  }, [onClose]);

  return (
    <div
      class="fixed z-50 bg-base-100 shadow-xl rounded-lg border border-base-200 p-1 flex flex-col min-w-[150px] animate-fade-in"
      style={{ top: y, left: x }}
      onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
    >
      <div class="px-3 py-2 text-xs font-bold opacity-50 border-b border-base-200 mb-1">
        Player Actions
      </div>

      {onKick && (
        <button
          type="button"
          class="btn btn-ghost btn-xs justify-start text-warning"
          onClick={() => {
            onKick(playerId);
            onClose();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
              clip-rule="evenodd"
            />
          </svg>
          Kick Player
        </button>
      )}

      {onBan && (
        <button
          type="button"
          class="btn btn-ghost btn-xs justify-start text-error"
          onClick={() => {
            onBan(playerId);
            onClose();
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-3 w-3 mr-2"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M13.477 14.89A6 6 0 015.11 6.524l8.367 8.368zm1.414-1.414L6.524 6.11a6 6 0 018.367 8.367zM18 10a8 8 0 11-16 0 8 8 0 0116 0z"
              clip-rule="evenodd"
            />
          </svg>
          Ban Player
        </button>
      )}
    </div>
  );
};
